<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div v-if="isLoading">
          <Loader />
        </div>
        <allergies-table 
          :allergies="allergies" 
          :refresh="fetchData"
          :searchQuery="searchTerm"
          v-else />
      </div>
    </div>
  </div>
</template>
 
<script>
import AllergiesTable from "./components/AllergiesTable.vue";
import Loader from "./components/Loader.vue";
import { fetchAllergies } from "../api/services/services";
import { ElLoading } from "element-plus";
import { ref } from "vue";

const isLoading = ref(false);
const allergies = ref([]);
const searchTerm = ref("");

export default {
  name: "allergies",
  components: {
    AllergiesTable,
    Loader,
  },
  setup() {
    const fetchData = async (search, page) => {
      searchTerm.value = search;
      isLoading.value = true;
      try {
        const response = await fetchAllergies(search, page);
        allergies.value = response.data;

        console.log(allergies.value);
      } catch (error) {
        console.log(error);
      } finally {
        isLoading.value = false;
      }
    };

    const fullScreenLoader = () => {
      ElLoading.service({
        lock: true,
        text: "Loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    };

    return {
      fullScreenLoader,
      fetchData,
      searchTerm,
      allergies,
      isLoading,
    };
  },
  mounted() {
    this.fetchData("", 1);
  },
};
</script>
